import { GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { 
	formatDate, 
	formatDateAndTime, 
	moneyFormat, 
	enumToStringConverter 
} from "../../../helpers/appHelpers";
import { REIMBURESEMENT_REQUEST_STATUS } from "../../../models/reimbursement-request.dto";
import { Avatar } from "@mui/material";

const CommonColumns: GridColDef[] = [
	{
		field: "title",
		headerName: "Title",
		headerClassName: "super-app-theme--header",
		minWidth: 250,
		flex: 1,
	},
	{
		field: "description",
		headerName: "Description",
		minWidth: 400,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "amount",
		headerName: "Amount",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.row?.currency?.currency?.code + " " + moneyFormat(params.value),
	},
	{
		field: "status",
		headerName: "Status",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		renderCell(params) {
			return (
				<div 
					className="rounded-lg px-4 py-2 min-w-[80px] text-center relative font-semibold overflow-hidden"
					style={{ color: getReimbursementStatusColor(params.value) }}
				>
					<div 
						className="absolute inset-0" 
						style={{ 
							background: getReimbursementStatusColor(params.value), 
							opacity: "15%"
						}}
					/>
					<p>{enumToStringConverter(params.value)}</p>
				</div>
			);
		},
	},
	{
		field: "expenditureDate",
		headerName: "Expenditure Date",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => {
			const expenditureDate = formatDate(params);
			return expenditureDate;
		},
	},
	{
		field: "createdAt",
		headerName: "Date Created",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		sortComparator: (date1, date2) => new Date(date1).getTime() - new Date(date2).getTime(),
		valueGetter: (params: GridValueGetterParams) => {
			const createdOn = formatDateAndTime(params);
			return createdOn;
		},
	},
	{
		field: "modifiedAt",
		headerName: "Last Date Modified",
		minWidth: 180,
		flex: 1,
		headerClassName: "super-app-theme--header",
		sortComparator: (date1, date2) => new Date(date1).getTime() - new Date(date2).getTime(),
		valueGetter: (params: GridValueGetterParams) => {
			const modifiedOn = formatDateAndTime(params);
			return modifiedOn;
		},
	},
	{
		field: "actions",
		headerName: "Actions",
		cellClassName: "actions",
		headerClassName: "super-app-theme--header",
	}
]

export const YourClaimsTableColumns: GridColDef[] = [
	...CommonColumns,
	// {
	// 	field: "approver",
	// 	headerName: "Approver",
	// 	minWidth: 250,
	//	flex: 1,
	// 	headerClassName: "super-app-theme--header",
	// 	renderCell(params) {
	// 		return (
	// 			<div className="flex items-center space-x-4">
	// 				<Avatar
	// 					src={params.value?.photoUrl}
	// 					alt="Dp"
	// 					className="w-10 h-10 rounded-full"
	// 				/>
	// 				<p>{(params.value?.firstName || "") + " " + (params.value?.lastName || "")}</p>
	// 			</div>
	// 		);
	// 	},
	// },
];

export const SuperviseesClaimsColumns: GridColDef[] = [
	{
		field: "employee",
		headerName: "Employee",
		minWidth: 250,
		flex: 1,
		headerClassName: "super-app-theme--header",
		renderCell(params) {
			return (
				<div className="flex items-center space-x-4">
					<Avatar
						src={params.value?.photoUrl}
						alt="Dp"
						className="w-10 h-10 rounded-full"
					/>
					<p className="truncate">{(params.value?.firstName || "") + " " + (params.value?.lastName || "")}</p>
				</div>
			);
		},
	},

	...CommonColumns,
];

export const getReimbursementStatusColor = (status: REIMBURESEMENT_REQUEST_STATUS) => {
	switch(status) {
		case "APPROVED":
			return "#4CAF50"
		case "COMPLETED":
			return "#808080"
		case "REJECTED":
			return "#F44336"
		case "SUBMITTED":
			return "#FFC107"
		case "QUERIED":
			return "#2196F3"
		default: 
			return "#ADD8E6"
	}
};